<template>
	<vx-card class="vx-col w-full create-order-manager">
		<h1>{{ $t('createOrder') }}</h1>
		<div class="vx-row mt-5">
			<div class="vx-col w-full mb-2">
				<vs-input
					v-model="name"
					v-validate="'required|min:5'"
					:label="$t('topic')"
					type="text"
					:placeholder="$t('newtonsLaw')"
					name="name"
					class="w-full"
				/>
				<span v-if="errors.first('name')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>
		</div>
		<div v-if="!isBoundToClient" class="vx-row">
			<div class="vx-col sm:w-1/2 w-full mb-2">
				<vs-input
					v-model="email"
					v-validate="'required|email|min:5'"
					:label="$t('clientsEmail')"
					type="text"
					class="w-full"
					name="email"
				/>
				<span v-if="errors.first('email')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>
			<div class="vx-col sm:w-1/2 w-full mb-2">
				<div class="vs-component vs-con-input-label vs-input vs-input-primary">
					<label class="vs-input--label">{{ $t('site') }}</label>
					<div class="vs-con-input">
					</div>
					<v-select
						v-model="site"
						:options="sites"
						:reduce="site => site.uid"
						:clearable="false"
						label="name"
						name="site"
					>
						<template slot="selected-option" slot-scope="option">
							<div class="w-full pt-1 pb-1 pl-3 pr-3"
								:style="`background-color: ${option.highlightingBackground}; color: ${option.highlightingText};`">
								{{ option.domain }}
							</div>
						</template>
						<template #option="option">
							<div class="w-full pt-1 pb-1 pl-3 pr-3"
								:style="`background-color: ${option.highlightingBackground}; color: ${option.highlightingText};`">
								{{ option.domain }}
							</div>
						</template>
					</v-select>
				</div>
				<span v-if="errors.first('site')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col sm:w-1/2 md:w-1/3 w-full mb-2">
				<div class="vs-component vs-con-input-label vs-input vs-input-primary">
					<label class="vs-input--label">{{ $t('subjectArea') }}</label>
					<div class="vs-con-input">
					</div>
					<v-select
						v-model="area"
						v-validate="'required'"
						:options="subjects"
						:reduce="item => item.id"
						:clearable="false"
						label="name"
						name="area"
					/>
				</div>
				<span v-if="errors.first('area')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>
			<div class="vx-col sm:w-1/2 md:w-1/3 w-full mb-2">
				<div class="vs-component vs-con-input-label vs-input vs-input-primary">
					<label class="vs-input--label">{{ $t("workType") }}</label>
					<div class="vs-con-input">
					</div>
					<v-select
						v-model="type"
						v-validate="'required'"
						:reduce="item => item.id"
						:options="works"
						:clearable="false"
						label="name"
						name="type"
					/>
				</div>
				<span v-if="errors.first('type')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>
			<div class="vx-col sm:w-1/2 md:w-1/3 w-full mb-2">
				<div class="vs-component vs-con-input-label vs-input vs-input-primary">
					<label class="vs-input--label">{{ $t("qualityLevel") }}</label>
					<div class="vs-con-input">
					</div>
					<v-select
						v-model="level"
						v-validate="'required'"
						:options="levels"
						:reduce="country => country.id"
						:clearable="false"
						label="name"
						name="level"
					/>
				</div>
				<span v-if="errors.first('level')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>
			<div class="vx-col sm:w-1/2 md:w-1/4 w-full mb-2">
				<vs-input
					v-model="pages"
					v-validate="'required|numeric'"
					:label="$t('pagesAmount')"
					type="text"
					placeholder="120"
					name="pages"
					class="w-full"
				/>
				<span v-if="errors.first('pages')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>
			<div class="vx-col sm:w-1/2 md:w-1/4 w-full mb-2">
				<div class="vs-component vs-con-input-label vs-input vs-input-primary">
					<label class="vs-input--label">{{ $t('workLanguage') }}</label>
					<div class="vs-con-input">
					</div>
					<v-select
						v-model="lang"
						v-validate="'required'"
						:options="languages"
						:reduce="country => country.id"
						:clearable="false"
						label="name"
						name="lang"
					/>
				</div>
				<span v-if="errors.first('lang')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>
			<div class="vx-col sm:w-1/2 md:w-1/4 w-full mb-2">
				<vx-input-group>
					<div class="vs-component vs-con-input-label vs-input vs-input-primary">
						<label class="vs-input--label">{{ $t('dueDate') }}</label>
						<div class="vs-con-input">
						</div>
						<vs-datepicker
							v-model="date"
							format="dd.MM.yyyy"
							v-validate="'required'"
							:to="minDate"
							name="date"
						></vs-datepicker>
					</div>
					<span v-if="errors.first('date')" class="text-danger text-sm">
						{{ $t('fieldFilledIncorrect') }}
					</span>
				</vx-input-group>
			</div>
			<div class="vx-col sm:w-1/2 md:w-1/4 w-full mb-2">
				<vx-input-group>
					<div class="vs-component vs-con-input-label vs-input vs-input-primary">
						<label class="vs-input--label">{{ $t('dueTimeAuthor') }}</label>
						<div class="vs-con-input">
						</div>
						<vs-datepicker
							v-model="dueTimeAuthor"
							format="dd.MM.yyyy HH:mm"
							v-validate="'required'"
							:to="minDate"
							name="dueTimeAuthor"
							type="datetime"
						></vs-datepicker>
					</div>
					<span v-if="errors.first('dueTimeAuthor')" class="text-danger text-sm">
						{{ $t('fieldFilledIncorrect') }}
					</span>
				</vx-input-group>
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col w-full mb-2">
				<div class="vs-component vs-con-input-label vs-input vs-input-primary">
					<label class="vs-input--label">{{ $t('comment') }}</label>
					<div class="vs-con-input">
					</div>
					<vs-textarea v-model="about" name="about" v-validate="'min:3'"/>
				</div>
				<span v-if="errors.first('about')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col w-full mb-2">
				<div class="vs-component vs-con-input-label vs-input vs-input-primary">
					<div class="vs-con-input">
					</div>
					<vs-upload
						v-model="photo"
						:show-upload-button="false"
						:limit="3"
						@change="toggleFiles"
						accept=".jpg,.jpeg,.png,.xls,.xlsx,.docx,.odt,.rtf,pptx,.pdf,.txt,.csv,.zip,.page,.sav,.MP4,.MOV,.MPG,.AVI,.M4V,.3GP,.3GGP,.MX20,.MX18,.MX12,.r"
						name="photo"
						:text="$t('loadFile')"
					/>
				</div>
				<span v-if="errors.first('photo')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>
		</div>
		<div class="vx-row mt-10 ">
			<div class="vx-col w-full buttons">
				<vs-button class="mr-3 mb-2" @click="createOrder">{{ $t('create') }}</vs-button>
				<vs-button color="warning" type="border" class="mb-2" @click="$router.go(-1)">
					{{ $t('cancel') }}
				</vs-button>
			</div>
		</div>
	</vx-card>
</template>

<script>
	import vSelect from "vue-select";
	import Datepicker from 'vuejs-datepicker';
	import moment from 'moment';
	import databaseManager from "@/mixins/databaseManager";
	import notifier from "@/mixins/notifier";

	export default {
		name: "CreateTicket",
		mixins: [databaseManager, notifier],
		data() {
			return {
				area: '',
				name: '',
				type: '',
				level: '',
				pages: '',
				lang: '',
				date: new Date(),
				dueTimeAuthor: '',
				about: '',
				email: '',
				site: '',
				files: [],
				photo: [],

				levels: [],
				languages: [],
				works: [],
				subjects: [],
				sites: [],
			}
		},
		computed: {
			minDate() {
				return new Date()
			},
			clientId() {
				return this.$route.params.clientId;
			},
			isBoundToClient() {
				return this.clientId !== undefined;
			}
		},
		methods:{
			toggleFiles(err, files) {
				this.files = files;
			},
			async saveFiles(){
				if(this.files.length === 0) return [];

				const formData = this.$formData({files: this.files});
				const res = await this.$http.post('/upload/many', formData);
				return res.data.data.map(item => item.path);
			},
			async getClientInfo() {
				if(!this.isBoundToClient) {
					return {
						email: this.email,
						website_uid: this.site
					};
			 	}

				const client = await this.dbGetClient(this.clientId);
				return {
					email: client.email,
					website_uid: client.uid
				};
			},
			async createOrder(){
				try{
					if(await this.$validator.validateAll() !== true) return;

					let files = await this.saveFiles();

					let formData = {
						name: this.name,
						subject: this.area,
						work_types: [{
							work_type: this.type,
							pages_number: this.pages,
						}],
						quality_level: this.level,
						pages_number: this.pages,
						language: this.lang,
						due_date: moment(this.date).format('YYYY-MM-DD'),
						dueTimeAuthor: moment(this.dueTimeAuthor).format("YYYY-MM-DD HH:mm:ss"),
						description: this.about,
						files: files
					};

					const { email, website_uid } = await this.getClientInfo();
					formData.email = email;
					formData.website_uid = website_uid;
					console.log(email, website_uid);

					const role = this.$store.state.auth.role;
					await this.$http.post(`/${role}/order/create`, formData);

					this.notifySuccess(this.$t('orderWasCreatedSuccessfully'));

					this.$router.back();

				}catch (e) {
					if(e.errors){
						Object.values(e.errors).forEach(err=>{
							this.notifyError(err[0])
						})
					}else{
						this.notifyError(e.message);
					}
				}
			},
		},
		async mounted () {
			const role = this.$store.state.auth.role;

			this.levels = (await this.$http.get("/settings/get-quality-levels")).data.data;
			this.languages = (await this.$http.get("/settings/get-languages")).data.data;
			this.works = (await this.$http.get("/settings/get-work-types")).data.data;
			this.subjects = (await this.$http.get("/settings/get-subjects")).data.data;
			this.sites = (await this.$http.get(`/${role}/website`)).data.data;

			this.level 		= this.levels[0] 		? this.levels[0].id 		: "";
			this.lang	 	= this.languages[0] 	? this.languages[0].id 		: "";
			this.type 		= this.works[0] 		? this.works[0].id 			: "";
			this.area	 	= this.subjects[0] 		? this.subjects[0].id		: "";
			this.site 		= this.sites[0] 		? this.sites[0].uid 		: "";
		},
		components: {
			vSelect,
			Datepicker
		}
	}
</script>

<style lang="scss">
	.create-order-manager {
		.vs-con-input-label {
			width: 100%;
		}

		.vs__selected {
			min-height: 20px;
		}

		.buttons {
			display: flex;
			justify-content: flex-end;
		}

		.vs-textarea {
			height: 120px;
		}

		.vs-con-textarea {
			margin-bottom: 0;
		}

		.vx-input-group .append-text.btn-addon .vs-button {
			height: 2.7rem;
			width: 2.7rem;
			justify-content: center;
			padding: 0 !important;
			margin-top: 21px;
			align-items: center;
			border-color: rgba(0, 0, 0, 0.2);
			border-left: 0 !important;
			background-color: #f7f6f6 !important;

		}

		.con-input-upload, .img-upload {
			margin: 0 !important;
			max-width: 200px;
			width: 100%;

			max-height: 191px;
			margin-right: 10px !important;
		}

		.con-img-upload, .img-upload {
			padding: 0;
		}

		.con-img-upload {
			margin-top: 20px;
		}
	}


</style>
